import type { AvatarConfig } from "@guandan/avatar-core";
import type { AvatarMotion } from "@guandan/avatar-renderer";
import { avatarPortraitForConfig } from "../game/avatar-portraits";
import { avatarImageUrl } from "../lib/user-avatar";

export function PortraitAvatar({
  config,
  motion = "idle",
  className = "",
  label = "现代中国角色头像",
}: {
  readonly config: AvatarConfig;
  readonly motion?: AvatarMotion;
  readonly className?: string;
  readonly label?: string;
}) {
  const portrait = avatarPortraitForConfig(config);
  const portraitId = config.customPortraitId ?? portrait.id;
  const imageUrl = config.customPortraitId
    ? avatarImageUrl(config.customPortraitId)
    : portrait.imageUrl;
  return (
    <div
      className={`portrait-avatar ${className}`.trim()}
      role="img"
      aria-label={label}
      data-gender={config.gender}
      data-motion={motion}
      data-portrait-id={portraitId}
    >
      <img src={imageUrl} alt="" aria-hidden="true" draggable={false} />
    </div>
  );
}
